<template>
  <!-- new fleet modal -->
  <b-modal-custom
    ref="fleetModal"
    :modal-class.sync="$options.data.themeClass"
    ok-only
    ok-title="Close"
    size="lg"
    @hidden="handleClose">

    <!-- header -->
    <template #modal-header>
      <h5>Fleet Details</h5>
      <b-button-close @click="handleClose">×</b-button-close>
    </template>

    <!-- add vessels -->
    <b-form-group class="mb-3">
      <label><strong>Add vessel</strong></label>

      <vessel-search
        class="vessels-multiselect"
        @input="handleAddVessel"/>

    </b-form-group>

    <!-- vessels table -->
    <h5 v-if="fleet.loading">Loading..</h5>
    <h5 v-else>"{{ fleet.fleetName }}" Vessels</h5>

    <fleet-vessel-table
      :fleet-id="fleetId"
      :fleets="fleets"
      :edit="true"
      :per-page="100"
      :key="fleetTableUpdateCount"
      @fleet-loaded="handleFleetLoaded"/>

  </b-modal-custom>
</template>

<script>
import { mapActions } from 'vuex';
import FleetVesselTable from './FleetVesselTable';
import VesselSearch from '../widgets/VesselSearch';
import BModalCustom from '@/base_components/BModalCustom';

export default {
  name: 'fleet-details-modal',

  components: {
    BModalCustom,
    VesselSearch,
    FleetVesselTable,
  },

  props: {
    fleetId: {
      type: String,
      default: () => '',
    },
    fleets: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      fleet: {
        loading: true,
        vessels: [],
      },

      searchLoading: false,
      searchResults: [],
      fleetTableUpdateCount: 0,
    }
  },

  methods: {
    ...mapActions('api/fleets', [
      'searchVessels',
      'addVessel',
    ]),

    computeExName(vessel) {
      if(vessel.exName) {
        return '(Ex name: ' + vessel.exName + ')';
      } else {
        return '';
      }
    },

    async handleAddVessel(item) {
      // optimistic update (availableVessels will be refreshed)
      this.fleet.vessels.push(item);

      // add with api and refresh
      await this.addVessel({
        fleetId: this.fleetId,
        imo: item.imo,
      });
      this.fleetTableUpdateCount += 1;
    },

    filterResults(searchResults) {
      const selectedVesselsIMO = this.fleet.vessels.map(vessel => vessel.imo);
      return searchResults.filter((vessel) => {
        return !selectedVesselsIMO.includes(vessel.imo);
      });
    },

    handleFleetLoaded(fleet) {
      this.fleet = fleet;
    },

    handleClose(evt) {
      evt.preventDefault();
      this.$emit('close-modal');
    },
  },

  computed: {
    availableVessels() {
      if(!this.searchResults) {
        return [];
      }

      const selectedVesselsIMO = this.fleet.vessels.map(vessel => vessel.imo);
      return this.searchResults.filter((vessel) => {
        return !selectedVesselsIMO.includes(vessel.imo);
      });
    },
  },

  watch: {
    async fleetId(value) {
      if(value) {
        this.$refs.fleetModal.show();
      } else {
        this.$refs.fleetModal.hide();
      }
    },
  },
}
</script>

<style scoped>
.search-multiselect,
.search-multiselect.multiselect--active {
  width: 100%;
}
</style>
